// extracted by mini-css-extract-plugin
export var infoItem = "_u4-2";
export var title = "_u4-0";
export var value = "_u4-1";